export default class Places {

  constructor() {
    let _scope = this;
    this.places = document.querySelectorAll('.places-wrapper');

    if (this.places.length) {
      for (let place of Array.from(this.places)) {
        _scope.init(place);
      }
    }
  }

  init(wrapper) {
    this.initViewSwitchButton(wrapper);
  }

  initViewSwitchButton(wrapper) {
    let _scope = this,
        buttons = wrapper.querySelectorAll('.button-wrapper .button');

    for(let button of Array.from(buttons)) {
      button.addEventListener('click', function () {
        if(button.getAttribute('data-type')) {
          wrapper.setAttribute('data-view', button.getAttribute('data-type'));
        }

        if(button.getAttribute('data-type') === 'map') {
          _scope.handleMapView(wrapper);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': 'Karte',
            'item_id': 'Bachland'
          });
        }
      });
    }
  }

  handleMapView (wrapper) {
    let maps = wrapper.getElementsByClassName('places-map');

    if (window.UC_UI && window.UC_UI.isInitialized()) {
      for(let s of Array.from(window.UC_UI.getServicesBaseInfo())) {
        if(s.name === 'Google Maps') {
          if(s.consent.status && maps.length) {
            for(let map of Array.from(maps)) {
              Places.loadGoogleMaps(map);
            }
          }
        }
      }
    } else {
      window.addEventListener('UC_UI_INITIALIZED', function(e) {
        for(let s of Array.from(window.UC_UI.getServicesBaseInfo())) {
          if(s.name === 'Google Maps') {
            if(s.consent.status && maps.length) {
              for(let map of Array.from(maps)) {
                Places.loadGoogleMaps(map);
              }
            }
          }
        }
      });
    }
  }

  static loadGoogleMaps(map) {
    const loadGoogleMapsAPI = require('load-google-maps-api');

    if(!window.gmload) {
      loadGoogleMapsAPI({
        key: 'AIzaSyBxDTK8CsFB1MCfIVYtRdeCvrF7UFqhsAo',
        language: document.documentElement.getAttribute('lang')
      }).then(function() {
        Places.drapMap(map);
        window.gmload = true;
      }).catch((err) => {
        console.error(err);
      });
    } else {
      Places.drapMap(map);
    }
  }

  static drapMap (map) {
    let places = map.querySelectorAll('[data-place]'),
        markers = [],
        infowindow = null;

    if(map.getAttribute('data-init') !== '1') {

      let bounds = new google.maps.LatLngBounds(),
          googlemap = new google.maps.Map(map, {
            zoom: 11
          });

      for(let place of Array.from(places)) {

        let marker = new google.maps.Marker({
          position: { lat: parseFloat(place.getAttribute('data-lat')), lng: parseFloat(place.getAttribute('data-lng')) },
          animation: google.maps.Animation.DROP,
          icon: {
            url: "/typo3conf/ext/ondigoconfiguration/Resources/Public/Mask/2022-01-14_THUE_marker-outline.svg",
            size: new google.maps.Size(45, 45),
          },
          map: googlemap
        });

        marker.clickable = true;

        google.maps.event.addListener(marker, 'mouseover', function() {
          if(marker.clickable) {
            marker.setIcon({
              url: "/typo3conf/ext/ondigoconfiguration/Resources/Public/Mask/2022-01-14_THUE_marker.svg",
              size: new google.maps.Size(45, 45)
            });
          }
        });

        google.maps.event.addListener(marker, 'mouseout', function() {
          if(marker.clickable) {
            marker.setIcon({
              url: "/typo3conf/ext/ondigoconfiguration/Resources/Public/Mask/2022-01-14_THUE_marker-outline.svg",
              size: new google.maps.Size(45, 45)
            });
          }
        });

        marker.addListener('click', () => {
          if(infowindow !== null) {
            infowindow.close();
          }

          if(markers.length) {
            for (let m of Array.from(markers)) {
              m.setIcon({
                url: "/typo3conf/ext/ondigoconfiguration/Resources/Public/Mask/2022-01-14_THUE_marker-outline.svg",
                size: new google.maps.Size(45, 45)
              });

              m.clickable = true;
            }
          }

          marker.setIcon({
            url: "/typo3conf/ext/ondigoconfiguration/Resources/Public/Mask/2022-01-14_THUE_marker.svg",
            size: new google.maps.Size(45, 45)
          });

          marker.clickable = false;

          infowindow = new google.maps.InfoWindow({
            content: '<h3><strong>' + place.getAttribute('data-title') + '</strong></h3><div class="button-wrapper" data-type="default"><a class="button" href="' + place.getAttribute('data-linktarget') + '"><span class="on-icon-right"></span>' + place.getAttribute('data-linktext') + '</a></div>',
          });

          infowindow.open({
            anchor: marker,
            map: googlemap
          });
        });

        bounds.extend(marker.position);
        markers.push(marker);
      }

      googlemap.fitBounds(bounds);

      map.setAttribute('data-init', '1');
    }
  }
}